import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';


let visualSwiper = null;
let gallerySwiper = null;

const BREAKPOINT = 1440;

function initVisual() {
  if (window.innerWidth < BREAKPOINT) {
    if (!visualSwiper) {
      visualSwiper = new Swiper('.visual-swiper', {
        modules: [Navigation, Autoplay],
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: {
        nextEl: '.visual-next',
        prevEl: '.visual-prev',
      },

      });
    }
  } else {
    if (visualSwiper) {
      visualSwiper.destroy(true, true);
      visualSwiper = null;
    }
  }
}

function initGallery() {
  if (!gallerySwiper) {
    gallerySwiper = new Swiper('.gallery-swiper', {
      modules: [Navigation, Autoplay],
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
slidesPerView: 'auto',
centeredSlides: true,

      spaceBetween: 10,

      navigation: {
        nextEl: '.gallery-next',
        prevEl: '.gallery-prev',
      },

      breakpoints: {
        1440: {
          slidesPerView: 3,
          spaceBetween: 114,
        },
      },
    });
  }
}

function initAllSwipers() {
  initVisual();
  initGallery();
}

window.addEventListener('load', initAllSwipers);
window.addEventListener('resize', () => {
  initVisual();
});